import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'atrius-app-bar-logo-area',
  template: `
    <div>
      <ng-content></ng-content>
    </div>
  `,
  styleUrls: ['./logo-area.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LogoAreaComponent {}
